module.exports = __webpack_public_path__ + "static/media/jihad-lahtal-feedback.469f6861.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/jihad-lahtal-feedback.png
// module id = 209
// module chunks = 0